export default __webpack_public_path__ + "static/media/Bracers of Effulgent Devotion.9a1d314e.jpg";